<template>
    <div>
        <div v-show="!showAddStore">
            <div v-if="file === null">
                <div class="table-responsive">
                    <table class="table table-hover table-vertical-center table-head-bg">
                        <thead>
                            <tr>
                                <th>
                                    {{ __('store.name') }}
                                </th>

                                <th>
                                    {{ __('general.street') }}
                                </th>

                                <th>
                                    {{ __('general.city') }}
                                </th>

                                <th>
                                    {{ __('general.actions') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="value.length > 0">
                        <tr v-for="store in value" :key="store.id">
                            <td>
                                {{ store.attributes.name }}
                            </td>
                            <td>
                                {{ store.attributes.address.street1 }}
                            </td>
                            <td>
                                {{ store.attributes.address.city }}
                            </td>
                            <td>
                                <actions>
                                    <action-button icon="fas fa-trash"
                                                   class="btn-hover-danger"
                                                   :title="__('actions.remove')"
                                                   @click="removeStore(store)"
                                    />
                                </actions>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4" class="text-center mt-2">
                                    {{ __('data-tables.no_records') }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mt-3">
                    <button class="btn btn-sm btn-outline-success" type="button" @click="showAddStore = true">
                        <i class="fas fa-plus-square mr-1"/>
                        {{ __('actions.store.select_more') }}
                    </button>
                    <div class="my-5 text-muted">{{ __('general.or') }}</div>
                </div>
            </div>
            <div>
                <label class="font-weight-bold">{{ __('brand.distribution.store_list') }}</label>
                <input class="d-block" type="file" accept=".xls,.xlsx,.csv,.tsv,.json,.odt" @input="fileSelected">
                <span class="form-text text-muted">
                    {{ __('brand.distribution.file_types') }}
                </span>
            </div>
        </div>
        <div v-show="showAddStore">
            <search-store v-model="searchedStore"/>

            <div class="mt-3">
                <button class="btn btn-success" type="button" @click="addSearchedStore()" :disabled="!searchedStore.id">
                    <i class="fas fa-plus-square mr-1"/>
                    {{ __('actions.store.add_to_list') }}
                </button>
                <button class="btn btn-default btn-hover-warning" type="button" @click="showAddStore = false">
                    <i class="fas fa-times mr-1"/>
                    {{ __('actions.abort') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SearchStore from './SearchStore'
import Actions from '@components/TableComponents/Actions'
import ActionButton from '@components/TableComponents/ActionButton'

export default {
    components: {
        SearchStore,
        Actions,
        ActionButton,
    },

    props: {
        value: Array,
        file: File,
    },

    data() {
        return {
            showAddStore: false,
            searchedStore: {
                id: null,
                attributes: {
                    name: '',
                    address: {
                        street1: '',
                    },
                },
            },
        }
    },

    methods: {
        fileSelected(e) {
            this.$emit('file', e.target.files[0])
        },

        addSearchedStore() {
            for (let store of this.value) {
                if (this.searchedStore.id === store.id) {
                    return //Already added
                }
            }

            let newStores = this.value
            newStores.push(this.searchedStore)
            this.$emit('input', newStores)
            this.showAddStore = false
        },

        removeStore(store) {
            let filtered = []
            for (let s of this.stores) {
                if (s.id !== store.id) {
                    filtered.push(s)
                }
            }
            this.$emit('input', filtered)
        },
    },
}
</script>
